import React from 'react';

export const HelpCanvas: React.FC = () => {
    return (
        <div>
            Help ...
        </div>
    );
};

